import { Tag } from '@jouzen/ecom-components/v3/Tag';
import { useTranslations } from 'next-intl';
import type { MouseEvent } from 'react';

import { EventType } from '@/analytics/types';
import ArticleCardsModule from '@/app/components/ArticleCardsModule';

import { ARTICLE_CARDS, ARTICLE_IMAGE } from './_data/homePress';

const HomePress = () => {
  const t = useTranslations();

  const handleLinkClick = async (
    event: MouseEvent<HTMLAnchorElement>,
  ): Promise<void> => {
    const { href } = event.currentTarget;
    const siteName = event.currentTarget.dataset['siteName'];
    await window.ouraAnalytics.track(EventType.LinkClicked, {
      cta: siteName,
      location: 'body',
      path: href,
    });
  };

  return (
    <ArticleCardsModule
      articleCards={ARTICLE_CARDS}
      articleImage={ARTICLE_IMAGE}
      eyebrowText="press_eyebrow"
      eyebrowTextColor="light"
      mobileSliderAriaLabels={[
        t('footer_articles_aria_forbes'),
        t('footer_articles_aria_oprah_daily'),
        t('footer_articles_aria_time'),
      ]}
      onClick={handleLinkClick}
      swipeableDotsProps={{
        activeColor: 'sandstone-200',
        color: 'sandstone-500',
      }}
      wrapperClass="bg-gray-600"
      imageTag={() => (
        <div>
          <Tag variant="lightSandstone" size="small">
            {t('featured_article_tag')}
          </Tag>
        </div>
      )}
    />
  );
};

export default HomePress;
